
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","viewBox":"-1 0 22 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 1.455c-2.264 0-5.349.194-7.307.336-.65.048-1.155.563-1.155 1.192v.71l7.84 4.118c.387.203.857.203 1.245 0l7.839-4.118v-.71c0-.63-.504-1.144-1.155-1.192-1.958-.142-5.043-.336-7.307-.336zm8.462 3.902L11.37 9.082a2.963 2.963 0 01-2.74 0L1.538 5.357v7.66c0 .63.504 1.144 1.155 1.192 1.958.142 5.043.337 7.307.337 2.264 0 5.349-.195 7.307-.337.65-.048 1.155-.563 1.155-1.192v-7.66zM2.574.341C4.534.198 7.671 0 10 0c2.33 0 5.466.198 7.426.341C18.89.448 20 1.606 20 2.983v10.034c0 1.377-1.11 2.535-2.574 2.642-1.96.143-5.097.341-7.426.341-2.33 0-5.466-.198-7.426-.341C1.11 15.552 0 14.394 0 13.017V2.983C0 1.606 1.11.448 2.574.34z","fill":"currentColor"}})])
          )
        }
      }
    